import { Box } from "@chakra-ui/react";
import { getWidgetWidth } from "@govisupro/controls";
import { animations } from "@govisupro/studio";
import React from "react";
import { DisplaySlate } from "../../utils/slate";
import "./index.css";
export const PlayerDevice = ({ layoutItem, screenWidth, }) => {
    var _a, _b, _c, _d, _e;
    const textData = layoutItem.widget.data;
    const WidgetAnimation = (_a = animations.find((animation) => { var _a; return animation.type === ((_a = layoutItem.animations) === null || _a === void 0 ? void 0 : _a.apparition.type); })) === null || _a === void 0 ? void 0 : _a.wrapper;
    const widgetWidth = getWidgetWidth({
        layoutItemWidth: layoutItem.width,
        screenWidth,
        scale: (_b = layoutItem.scale) !== null && _b !== void 0 ? _b : 1,
    });
    return (React.createElement(Box, { bgColor: textData.backgroundColor, width: widgetWidth }, ((_c = layoutItem.animations) === null || _c === void 0 ? void 0 : _c.apparition) && WidgetAnimation ? (React.createElement(WidgetAnimation, { duration: (_d = layoutItem.animations) === null || _d === void 0 ? void 0 : _d.apparition.duration, delay: (_e = layoutItem.animations) === null || _e === void 0 ? void 0 : _e.apparition.delay },
        React.createElement(DisplaySlate, { text: textData.text, scale: 1 }))) : (React.createElement(DisplaySlate, { text: textData.text, scale: 1, player: true }))));
};
